import { palette } from '@dev/ee-components';
import styled, { css } from 'styled-components';

export const OnboardingStepWrapper = styled.div`
    border-radius: 4px;
    border: 1px solid ${palette.gray[3]};
`;

interface OnboardingStepHeaderProps {
    $isDisabled: boolean;
    $isMobile: boolean;
}

export const OnboardingStepHeader = styled.div<OnboardingStepHeaderProps>`
    position: relative;
    padding: ${({ $isMobile }): string => ($isMobile ? '32px 20px' : '32px 40px')};
    display: grid;
    grid-template-columns: 32px auto 32px;
    gap: 24px;

    &:after {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background: ${({ $isDisabled }) => ($isDisabled ? palette.gray[3] : palette.indigo[2])};
        display: ${({ $isDisabled }) => ($isDisabled ? 'block' : 'none')};
        opacity: 0.4;
    }
    
    ${({ $isDisabled }) => {
        if ($isDisabled) {
            return;
        }
        return css`
            &:hover {
                cursor: pointer;
            }

            &:hover:after {
                display: block;
            }
        `;
    }}};
`;

interface OnboardingStepHeaderNoProps {
    $isDisabled: boolean;
}

export const OnboardingStepHeaderNo = styled.div<OnboardingStepHeaderNoProps>`
    width: 31px;
    height: 31px;
    border-radius: 50%;
    background: ${({ $isDisabled }) => ($isDisabled ? palette.gray[2] : palette.basic.paper)};
    box-shadow: 0px 3px 6px 0px #2d374829;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid ${({ $isDisabled }) => ($isDisabled ? palette.gray[3] : 'transparent')};
`;

export const OnboardingStepHeaderTitle = styled.div<{ $isMobile: boolean }>`
    display: flex;
    justify-content: space-between;
    gap: 24px;
    padding-top: 2px;
    ${({ $isMobile }) => {
        if (!$isMobile) {
            return;
        }
        return css`
            flex-direction: column;
        `;
    }}
`;

export const OnboardingStepReopen = styled.div`
    position: relative;
    z-index: 1;
`;

export const OnboaringStepCollapseContent = styled.div<{ $isMobile: boolean }>`
    padding: ${({ $isMobile }): string => ($isMobile ? '8px 20px 32px 20px' : '8px 96px 32px 96px')};
    display: flex;
    flex-direction: column;
    gap: 40px;
`;

export const OnboardingCardStepSecondaryContent = styled.div`
    svg {
        max-width: 100%;
    }
`;

interface OnboaringStepCollapseContentGridProps {
    $isMobile: boolean;
}

export const OnboaringStepCollapseContentGrid = styled.div<OnboaringStepCollapseContentGridProps>`
    width: 100%;
    display: grid;
    grid-template-columns: auto 256px;
    gap: 40px;
    ${({ $isMobile }) => {
        if (!$isMobile) {
            return;
        }
        return css`
            grid-template-columns: auto;
            grid-template-rows: auto auto;
        `;
    }}
`;

export const OnboardingStepButtons = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 32px;
    align-items: center;
`;

export const OnboardingCardStepContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

export const OnboardingCardStepFeature = styled.div`
    display: grid;
    grid-template-columns: 24px auto;
    word-break: break-word;
    gap: 16px;
`;

export const OnboardingCardStepStyledTip = styled.div`
    .singleTip {
        width: 100%;
        margin-bottom: 0;
        flex: 1;
        .textLimiter {
            max-width: 100%;
        }
        [role='button'] {
            width: 100%;
        }
    }
`;

export const OnboardingCardStepStyledTipContent = styled.span`
    color: ${palette.gray[7]};
    a {
        color: ${palette.indigo[6]};
    }
`;
